module.exports = __webpack_public_path__ + "img/ocean-hotel-5.4cda7e5c.jpg";